// Add the selected product (with its gift properties) through the theme's own cart flow,
// then open the side cart drawer. 02.11: no more direct redirect to checkout.
import { CartLinesUpdateEvent } from '@shopify/events';

const messages = {
  fr: 'Impossible d’ajouter le produit. Veuillez réessayer.',
  de: 'Das Produkt konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.',
  sv: 'Produkten kunde inte läggas till. Försök igen.',
  en: 'Could not add the product. Please try again.',
  pl: 'Nie udało się dodać produktu. Spróbuj ponownie.',
  it: 'Impossibile aggiungere il prodotto. Riprova.'
};

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.plp__form')) return;
  event.preventDefault();
  if (form.dataset.submitting === 'true') return;
  form.dataset.submitting = 'true';
  const button = form.querySelector('[type="submit"]');
  const error = form.querySelector('[data-plp-cart-error]');
  if (error) error.hidden = true;
  if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
  const root = window.Shopify?.routes?.root || '/';
  let redirecting = false;
  try {
    const data = new FormData(form);
    data.delete('return_to');
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId).filter(Boolean);
    if (sectionIds.length) data.append('sections', sectionIds.join(','));

    const deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(data.get('id')), quantity: Number(data.get('quantity')) || 1 }],
      promise: deferred.promise
    }));

    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST', body: data, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    });
    const added = await response.json();
    if (!response.ok || added.status) {
      deferred.resolve({ cart: null, detail: { didError: true } });
      throw new Error(added.description || added.message);
    }
    const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'plp-form', sourceId: form.id || 'plp-form', itemCount: 1, sections: added.sections, didError: false }
    });

    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      await customElements.whenDefined('theme-drawer');
      setTimeout(() => { if (!drawer.hasAttribute('open') && typeof drawer.open === 'function') drawer.open(); }, 150);
    } else {
      redirecting = true;
      window.location.assign(`${root}cart`);
    }
  } catch (exception) {
    if (error) {
      error.textContent = exception.message || messages[document.documentElement.lang.split('-')[0]] || messages.en;
      error.hidden = false;
    }
  } finally {
    if (!redirecting) {
      delete form.dataset.submitting;
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  }
});
